import { createFeatureSelector, createSelector } from '@ngrx/store';
import { VehicleLocation } from '@polaris-customerweb/sharedcomponents.garage';
import { selectVinToVehicleMap } from '..';
import { selectActiveGarageItemVehicleId } from '../../garage/garage.selectors';
import {
    VehicleLocationState,
    vehicleLocationFeatureKey,
} from './vehicle-location.reducer';

export const vehicleLocationState = createFeatureSelector<VehicleLocationState>(
    vehicleLocationFeatureKey
);

export const selectVehicleLocationState = createSelector(
    vehicleLocationState,
    (state) => state.collectionEffectState
);

export const selectVehicleLocations = createSelector(
    vehicleLocationState,
    selectVinToVehicleMap,
    (state, vinToVehicleMap) => {
        const result = state.vehicleLocations.reduce<VehicleLocation[]>(
            (locations, dto) => {
                if (!dto.locations || dto.locations.length === 0) {
                    return locations;
                }

                const vehicle = vinToVehicleMap[dto.vin || ''];
                if (!vehicle) {
                    return locations;
                }

                return [
                    ...locations,
                    new VehicleLocation(
                        dto,
                        'en-US',
                        vehicle.id,
                        vehicle.getIconType(),
                        vehicle.name
                    ),
                ];
            },
            []
        );
        return result;
    }
);

export const selectVehicleLocationsAreLoaded = createSelector(
    vehicleLocationState,
    (state) => state.hasFetchedAllLocations
);

export const selectActiveVehicleLocation = createSelector(
    selectVehicleLocations,
    selectActiveGarageItemVehicleId,
    (vehicleLocations, vehicleId) => {
        return vehicleLocations.find(
            (vehicleLocation) => vehicleLocation.vehicleId === vehicleId
        );
    }
);

export const selectVehicleLocationByVehicleId = (vehicleId: string) =>
    createSelector(selectVehicleLocations, (vehicleLocations) =>
        vehicleLocations.find(
            (vehicleLocation) => vehicleLocation.vehicleId === vehicleId
        )
    );
